namespace $ {

	export class $shm_hitalama_opencode_config extends $mol_object2 {

		static agent_domain_default() {
			return 'crus.51-250-36-140.ip.hyoo.ru'
		}

		static online_agent( next?: boolean ) {
			return $mol_state_local.value< boolean >( '$' + 'hitalama_domain_page_online_agent', next ) ?? false
		}

		static agent_domain_suffix() {
			const location = $mol_dom_context.document?.location
			if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return '158-160-195-195.ip.hyoo.ru'
			}
			if( location?.protocol === 'https:' && location.hostname === 'dashboard.shmakov.media' ) {
				return this.agent_domain_default()
			}
			if( this.online_agent() ) return this.agent_domain_default()
			return ''
		}

		static agent_url( subdomain: string, local: string ) {
			const settings = ( $ as any ).$shm_hitalama_settings
			const stored = String( settings?.agent_url?.() ?? '' ).trim()
			if( stored ) return stored
			const suffix = this.agent_domain_suffix()
			return suffix ? `https://${ subdomain }.${ suffix }` : local
		}

		static agent_preview_url( path: string ) {
			const module = path.replace( /^\/+|\/+$/g, '' )
			if( !module ) return 'about:blank'

			const suffix = this.agent_domain_suffix()
			const host = suffix ? `https://devserver.${ suffix }` : 'http://localhost:9080'

			return `${ host }/${ module }/-/test.html`
		}

		static mcp_url() {
			const stored = $mol_state_local.value< string >( 'hitalama_mcp_url' )
			if( stored ) return this.mcp_http_url( stored )

			const suffix = this.agent_domain_suffix()
			if( suffix ) return `https://mcp.${ suffix }`
			return 'http://127.0.0.1:4817'
		}

		static mcp_http_url( url: string ) {
			const parsed = new URL( url, $mol_dom_context.document?.location.href )
			if( parsed.protocol === 'ws:' ) parsed.protocol = 'http:'
			if( parsed.protocol === 'wss:' ) parsed.protocol = 'https:'
			parsed.pathname = parsed.pathname.replace( /\/hitalama-mcp$/, '' ).replace( /\/mcp$/, '' )
			parsed.search = ''
			parsed.hash = ''
			return parsed.toString().replace( /\/$/, '' )
		}

	}

}
